module.exports = __webpack_public_path__ + "static/media/WheatStage112.9fcbe2bb.PNG";